"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stringToLength = (str, length) => {
    if (!length) {
        return str;
    }
    if (str.length >= length) {
        return str.substr(0, length);
    }
    let _str = str;
    for (let idx = str.length; idx < length; idx++) {
        _str += ' ';
    }
    return _str;
};
;
;
class JsonCsv {
    constructor(options) {
        var _a;
        this.headers = options === null || options === void 0 ? void 0 : options.headers;
        this.delim = (_a = options === null || options === void 0 ? void 0 : options.delim) !== null && _a !== void 0 ? _a : ',';
        this.headersLengthSpec = options === null || options === void 0 ? void 0 : options.headersLengthSpec;
    }
    parse(obj) {
        var _a;
        if ((_a = this.headers) === null || _a === void 0 ? void 0 : _a.length) {
            const row = this.headers
                .map(header => { var _a; return this.parseValue(obj[header], (_a = this.headersLengthSpec) === null || _a === void 0 ? void 0 : _a[header]); })
                .join(this.delim);
            return row;
        }
        return Object.values(obj).join(',');
    }
    getHeaders() {
        return this.headers.join(this.delim);
    }
    parseValue(value, valueLength) {
        const regdelim = new RegExp(this.delim, 'g');
        if (!value) {
            return value;
        }
        if (typeof value === 'object' && value.length) {
            return stringToLength(value
                .map(v => v.toString().replace(regdelim))
                .join('->'), valueLength);
        }
        if (value instanceof Date) {
            return stringToLength(value.toISOString(), valueLength);
        }
        if (typeof value === 'object') {
            return stringToLength('Object');
        }
        return stringToLength(value.toString().replace(regdelim, ''), valueLength);
    }
    ;
}
exports.JsonCsv = JsonCsv;
;
//# sourceMappingURL=csv.js.map